var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 5.83333L15.6107 15.9521C15.5484 16.8243 14.8227 17.5 13.9483 17.5H7.05203C6.17763 17.5 5.4519 16.8243 5.3896 15.9521L4.66683 5.83333M8.8335 9.16667V14.1667M12.1668 9.16667V14.1667M13.0002 5.83333V3.33333C13.0002 2.8731 12.6271 2.5 12.1668 2.5H8.8335C8.37326 2.5 8.00016 2.8731 8.00016 3.33333V5.83333M3.8335 5.83333H17.1668",
    stroke: "#F8FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c2a291f91dc68bc11b8d5b6512c974ce.svg";
export { ForwardRef as ReactComponent };